import { Stack } from 'component-library';
import { Trans, useTranslation } from 'react-i18next';

import { useMethodologyPageLink } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useMethodologyPageLink';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
  MethodologyLink,
} from './Explainer';

export const SpeciesOccupancyExplainer = () => {
  const { t } = useTranslation();
  const methodologyPageLink = useMethodologyPageLink();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='species-occupancy-explainer'>{t('global.howDoWeMeasureThis')}</ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>
          {t('shared.ncaDetail.indicatorSpecies.occupancy.explainers.howDoWeMeasure.title')}
        </ExplainerTitle>
        <Stack spacing={8} className='items-start pb-6'>
          <ExplainerBody className='pb-0'>
            <ExplainerCopy
              title={t('shared.ncaDetail.indicatorSpecies.occupancy.explainers.howDoWeMeasure.speciesOccupancyTitle')}
              body={<Trans i18nKey='shared.ncaDetail.indicatorSpecies.occupancy.explainers.howDoWeMeasure.body' />}
            />
          </ExplainerBody>
          <MethodologyLink to={methodologyPageLink} />
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
